import React from 'react'
import { Header, Table, Button, Input, Form, Message} from 'semantic-ui-react'

import FileImage from '../../filepod/FileImage'
import FileShare from '../../filepod/FileShare'

export function Step3a(props) {
    if (props.currentStep !== 3) {
        return null
    }

    console.log(props.auth)

    const setPrices =(event) => {
        // console.log(event.target.value);
        
        // props.prices=event.target.value
        // props.handleChange =props.prices
      }
      


      
        return (

        <div className="form-group">
             <Header as='h1' textAlign='center'> Checkout</Header>
             <Message floated="center" style={{
                            background: "transparent",
                            border: "1px solid transparent",
                            boxShadow: "none",
                            padding: "0em 0em",
                            height: "6vw",
                           
                            // marginLeft: "1.2vw"
                          }}>
                                   <Button  fluid color='green' size='huge' style={{width:"100%" }} >Checkout</Button>
                          </Message>


            
    
            {/* <Table>
                <Table.Body>
                <Table.Row >
                        <Table.Cell style={{ padding: "40px" }} >
                            <Header as='h4' textAlign='center'>
                                Price: </Header>
                        </Table.Cell>
                        <Table.Cell >
                            <Form.Group grouped>
                                <Form.Field onChange={setPrices.bind(this)} 
                                // value={props.prices}
                                    label='Charge me the estimated amount and get started'
                                    value ='Charge me the estimated amount and get started'
                                    control='input'
                                    type='radio'
                                    name='htmlRadios'/>
                                <Form.Field  onChange={props.handleChange} 
                                    value="Get me a quote, don't start work"
                                    label="Get me a quote, don't start work"
                                    // value ="Get me a quote, don't start work"
                                    control='input'
                                    type='radio'
                                    name='htmlRadios'/>

                            </Form.Group>
                        </Table.Cell>
                    </Table.Row>


                    <Table.Row>
                        <Table.Cell style={{ padding: "40px" }} >
                            <Header as='h4' textAlign='center'>
                                Payment:</Header>
                        </Table.Cell>
                        <Table.Cell textAlign='left'>
                            <p>You will not be charged until your project has been reviewed by your project manager.</p>
                            <p>Purchase credits</p>
                            <p>You need 12 credits @ $115.00/credit  to start this project.  </p>
                        </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell style={{ padding: "40px" }} >
                            <Header as='h4' textAlign='center'>
                                Voucher:
                        </Header>
                        </Table.Cell>
                        <Table.Cell ><Input size='huge' placeholder='Enter Code...' style={{ width: "400px" }} /> <Button style={{ marginLeft: '30px' }} size='large'>Redeem</Button></Table.Cell>
                        <Table.Cell ><Input onChange={props.handleChange}  value={props.description} id='description' name='voucher' size='huge' placeholder='Enter Code...' style={{ width: "400px" }} /> 
                        <Button style={{ marginLeft: '30px' }} size='large'>Redeem</Button></Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table> */}
     <br></br>
{/* <Header> Upload Images</Header> */}
    <br></br>
    {/* <FileShare auth={props.auth} filesGroupId={props.filesGroupId} > </FileShare> */}
     
    {/* <FileShare auth={props.auth} filesGroupId={props.filesGroupId} oid={props.oid}> </FileShare> */}
    <FileImage auth={props.auth} filesGroupId={props.filesGroupId} oid={props.oid}></FileImage>


        </div>
    )
}

const serviceOptions = [
    {
      key: '1',
      text:  'Charge me the estimated amount and get started',
      value: 'Charge me the estimated amount and get started',
      image: { avatar: true, src:'/images/avatar/small/elliot.jpg' },
      size: 'small',
    },
    {
      key: '2',
      text: "Get me a quote, don't start work",
      value: "Get me a quote, don't start work",
      image: { avatar: true, src: '/images/avatar/small/elliot.jpg' },
      size: 'small',
    },
  ]


//   const setGender =(event) => {
//     console.log(event.target.value);
//   }
  

//   <div onChange={setGender.bind(this)}>
//   <input type="radio" value="MALE" name="gender"/> Male
//   <input type="radio" value="FEMALE" name="gender"/> Female
// </div>

// onChange={setPrices.bind(this)} 

// onChange={setPrices.bind(this)}